import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ErrorComponent } from '../confirm/error.component';
import { AppConfig } from '../util';
import { Router } from '@angular/router';
import { LoginErrorComponent } from '../confirm/loginError';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private baseURL: any = null;
  constructor(
    private http: HttpClient,
    private modalService: MatDialog,
    private router: Router,
    private appConfig: AppConfig
  ) {
    this.baseURL = appConfig.getServerURL();
  }

  public showerror() {
    // this.dialogService.addDialog(ErrorComponent, {
    //     title: 'Confirm title',
    //     message: 'Confirm message'
    // })
    const modal = this.modalService.open(ErrorComponent, {
      width: 'auto',
      data: { title: 'Confirm title', message: 'Confirm message' },
    });
  }

  public showLoginError() {
    // this.dialogService.addDialog(ErrorComponent, {
    //     title: 'Confirm title',
    //     message: 'Confirm message'
    // })
    const modal = this.modalService.open(LoginErrorComponent, {
      width: 'auto',
      data: { title: 'Confirm title', message: 'Confirm message' },
    });
  }

  // authentication with active directory credentials
  public login(username: string, password: string, loginas: string, ipAddress) {
    return this.http
      .post<any>(this.baseURL + 'login', {
        username: username,
        password: password,
        loginas: loginas,
        ip: ipAddress,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  // remove local storage data and forward to login page
  public logout() {
    localStorage.removeItem('data');
    localStorage.removeItem('user');
    localStorage.removeItem('errorMsg');
    localStorage.removeItem('cepData');
    localStorage.removeItem('cepUserList');
    localStorage.removeItem('userLogsData');
    localStorage.removeItem('userList');
    localStorage.removeItem('stakeHolder');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('formDetails');
    localStorage.removeItem('csd');
    localStorage.removeItem('selectedMonth');
    this.router.navigate(['/login']);
  }
  /**
   * Get Client IP Address
   */
  public getIPAddress() {
    return this.http.get('https://api.ipify.org/?format=json');
  }
  // Get users which are having leaving date >= current date
  public getCurrentAvailableUsers() {
    return this.http
      .post<any>(this.baseURL + 'getCurrentAvailableUsers', {})
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get skills List from skill Master
  public getSkillDetails(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getSkillDetails').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  //Get jira ticket status list
  public getJIRATicketStatusList(
    searchCSDNo: string,
    username: string,
    password: string,
    status: string
  ) {
    return this.http
      .post<any>(this.baseURL + 'getUsersAndToBePlanned', {
        searchCSDNo: searchCSDNo,
        username: username,
        password: password,
        status: status,
      })
      .pipe(
        map((res) => {
          if (res && res.data) {
          }
          return res.data[0].filteredIssues;
        })
      );
  }

  //Get selected ticket total planned hours
  public getSelectedTicketPlannedCount(selectedValue: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getSelectedTicketPlannedCount', {
        csdno: selectedValue,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  //Get users planned data
  public getUserPlannedData(
    selectedValue: any,
    startdate: any,
    enddate: any
  ): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getUserPlannedData', {
        csdno: selectedValue,
        startdate: startdate,
        enddate: enddate,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get user skill by using skill id
  public getUserSkillBySkillId(skillId: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getUserSkillBySkillId', { skillId: skillId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get HTML users details
  public getHtmlUsersDetails(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getHtmlUsersDetails').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get storyline users details
  public getStorylineUsersDetails(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getStorylineUsersDetails').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get lectora user details
  public getLectoraUsersDetails(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getLectoraUsersDetails').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get Booking data for reduce hours
  public getBookings(formData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getBookings', { formData: formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Booking data for reduce hours
  public getUserBookingData(formData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getUserBookingData', { formData: formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Booking data for reduce hours
  public getBookingData(formData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getBookingData', { formData: formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Booking data for reduce hours
  public updateBookingHours(bookingData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateBookingHours', {
        bookingData: bookingData,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all the users information list
  public getAllUsers(startDate) {
    return this.http
      .post<any>(this.baseURL + 'getAllUsers', { startDate: startDate })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // booked user
  public addBookedUser(
    changeCSDStatus: any,
    selectedCSD: any,
    currentCSDStatus: any,
    userBookingData: any,
    updatedUserData: any
  ) {
    return this.http
      .post<any>(this.baseURL + 'addBookedUser', {
        changeCSDStatus: changeCSDStatus,
        cSDNo: selectedCSD,
        cSDStatus: currentCSDStatus,
        bookedUsers: userBookingData,
        updatedUserData: updatedUserData,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  // delete user booking data
  public deleteUserData(
    deletedUser: any,
    selectedCSDNo,
    deletedUserList
  ): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'deleteBookedUser', {
        deletedUser: deletedUser,
        selectedCSDNo: selectedCSDNo,
        deletedUserList: deletedUserList,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get CSD info and generate consolidated report
  public getCEPReport(
    username: string,
    password: string,
    startDate: String,
    endDate: String,
    filterName: String
  ) {
    return this.http
      .post<any>(this.baseURL + 'CEPReport', {
        username: username,
        password: password,
        startDate: startDate,
        endDate: endDate,
        filterName: filterName,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // generate user logged data
  public getuserLogsReport(
    username: string,
    password: string,
    startDate: String,
    endDate: String,
    filterName: String
  ) {
    return this.http
      .post<any>(this.baseURL + 'userLogs', {
        username: username,
        password: password,
        startDate: startDate,
        endDate: endDate,
        filterName: filterName,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  // Get booked CSD inforamation data based on user
  public getUserTaskDetail(username: string, password: string) {
    return this.http
      .post<any>(this.baseURL + 'getUsersAndToBePlanned', {
        username: username,
        password: password,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get list of all CSD
  public getAllCSDs(startdate: any, enddate: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllCSDList', {
        startdate: startdate,
        enddate: enddate,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all CSD clinet name from JIRA
  public getAllCSDClinetNameFromJIRA(
    csdsStr,
    username,
    password,
    noOfCSD
  ): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllCSDClinetNameFromJIRA', {
        csdsStr: csdsStr,
        username: username,
        password: password,
        noOfCSD: noOfCSD,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // save user data
  public saveData(formDetails: any) {
    return this.http
      .post<any>(this.baseURL + 'addWorkallocation', formDetails)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // save applicants data
  public saveApplicantsData(formDetails: any) {
    return this.http
      .post<any>(this.baseURL + 'addApplicant', { formDetails: formDetails })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get workLoad data
  public getworkLoadData(formDetails: any) {
    return this.http.post<any>(this.baseURL + 'workload', formDetails).pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // save user data
  public saveUserData(formDetails: any) {
    return this.http
      .post<any>(this.baseURL + 'addResouce', { formDetails: formDetails })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // // save applicants data
  // public saveApplicantsData(formDetails: any) {
  //     return this.http.post<any>(this.baseURL + 'addApplicant', { formDetails: formDetails })
  //         .pipe(map(res => {
  //             return res.data;
  //         }))
  // }

  // delete user information
  public userDeletion(userInfo: any) {
    return this.http
      .post<any>(this.baseURL + 'deleteUser', { userInfo: userInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // update user information
  public updateUserData(formDetails: any) {
    return this.http
      .post<any>(this.baseURL + 'updateUser', { formData: formDetails })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // update user skill information
  public updationResouceSkills(formDetails: any, updateSkillSetData: any) {
    return this.http
      .post<any>(this.baseURL + 'updationResouceSkills', {
        formData: formDetails,
        updateSkillSetData: updateSkillSetData,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get All users list
  public getUsersList(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'fetchUser').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get All users list by post
  public getUsersListByPost(towerId?, supervisorEmail?): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'fetchUser', {
        towerId: towerId,
        supervisorEmail: supervisorEmail
          ? supervisorEmail.toLowerCase()
          : undefined,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get saved user data
  public fetchUserData(userId, towerId, supervisorEmail): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'fetchUser', {
        userId: userId,
        towerId: towerId,
        supervisorEmail: supervisorEmail.toLowerCase(),
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get saved user data
  public getBehDataForReport(): Observable<any> {
    return this.http.post<any>(this.baseURL + 'getBehDataForReport', {}).pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get saved user data
  public getFunDataForReport(): Observable<any> {
    return this.http.post<any>(this.baseURL + 'getFunDataForReport', {}).pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // fetch all functional skills
  public fetchAllFunSkills(userIds: any[]): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'fetchAllSkills', { userIds: userIds })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // fetch all skills
  public fetchAllBehSkills(userIds: any[]): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'fetchAllBehSkills', { userIds: userIds })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // fetch skill data
  public fetchSkillData(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'fetchSkillData').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // fetch skill data
  public fetchSkillDataPost(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'fetchSkillDataPost', { towerId: towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // fetch skill data
  public fetchBehSkillData(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'fetchBehSkillData').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // fetch skill data
  public fetchBehSkillDataPost(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'fetchBehSkillDataPost', { towerId: towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // save skills data
  public saveSkillsData(userSkillData, createdByEmail) {
    return this.http
      .post<any>(this.baseURL + 'saveSkillsData', {
        createdByEmail: createdByEmail,
        userSkillData: userSkillData,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all user list
  public getAllUserList() {
    return this.http.get<any>(this.baseURL + 'getAllUserList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get utilization resource data
  public getUtilizationResource(startDate, endDate) {
    return this.http
      .post<any>(this.baseURL + 'utilizationResource', {
        startDate: startDate,
        endDate: endDate,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get booked utilization resource data
  public getBookedUtilizationResource(startDate, endDate) {
    return this.http
      .post<any>(this.baseURL + 'bookedUtilizationResource', {
        startDate: startDate,
        endDate: endDate,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get resource history information
  public getResourcesHistory(startDate, endDate) {
    return this.http
      .post<any>(this.baseURL + 'getResourcesHistory', {
        startDate: startDate,
        endDate: endDate,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get resource skills history information
  public getResourcesSkillHistory(selectedUserId) {
    return this.http
      .post<any>(this.baseURL + 'getResourcesSkillHistory', {
        selectedUserId: selectedUserId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get resource beh skills history information
  public getResourcesBehSkillHistory(selectedUserId) {
    return this.http
      .post<any>(this.baseURL + 'getResourcesBehSkillHistory', {
        selectedUserId: selectedUserId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get intervention list
  public getInterventionList(skillId?: any): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getInterventions').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get intervention list
  public getUsersInterventionList(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getUsersInterventionList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }
  // save user interventions
  public saveUserInterventions(interventions) {
    return this.http
      .post<any>(this.baseURL + 'saveUserIntervention', {
        interventions: interventions,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // save user interventions
  public getUserInterventions(userId) {
    return this.http
      .post<any>(this.baseURL + 'getUserInterventions', { userId: userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // save user data
  public saveSkillRatingData(
    skillRatingData: any,
    currentUserSkill: any,
    isFunctional: any,
    towerId = null
  ) {
    if (isFunctional) {
      return this.http
        .post<any>(this.baseURL + 'saveSkillRatingData', {
          skillRating: skillRatingData,
          currentUserSkill: currentUserSkill,
          towerId: towerId,
        })
        .pipe(
          map((res) => {
            return res.data;
          })
        );
    } else {
      return this.http
        .post<any>(this.baseURL + 'saveBehSkillRatingData', {
          skillRating: skillRatingData,
          currentUserSkill: currentUserSkill,
          towerId: towerId,
        })
        .pipe(
          map((res) => {
            return res.data;
          })
        );
    }
  }

  // Get saved user data
  public fetchSkillRatingData(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getSkillRatingList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get all IBU Info
  public getAllIBUInfo(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getAllIBUInfo').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get all IBU Info
  public getAllIBUInfoByIbuId(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllIBUInfoByIbuId', { towerId: towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // update IBU Info
  public updateIBUInfo(ibuInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateIBUInfo', { ibuInfo: ibuInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save ibu info
  public saveIBUInfo(ibuInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveIBUInfo', { ibuInfo: ibuInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get users list api call
  public getTowerInfo(towerId, isFatchAll): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getTowerInfo', {
        towerId: towerId,
        isFatchAll: isFatchAll,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get users list api call
  public getTowerInfoByIbuId(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getTowerInfoByIbuId', { towerId: towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // Get towers list
  public getTowersListByIbuId(ibuId, functionId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getTowersListByIbuId', {
        ibuId: ibuId,
        functionId: functionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get towers info
  public getTowerList(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getTowerList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get position list
  public getPositionList(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getPositionList', { towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get training list
  public getTrainingList(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getTrainingList', { towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save tower Info
  public saveTowerInfo(towerInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveTowerInfo', { towerInfo: towerInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update tower Info
  public updateTowerInfo(towerInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateTowerInfo', { towerInfo: towerInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get management users list
  public getManagementUsersList(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getManagementUsersList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get management users list use by towerId
  public getManagementUsersListByTowerId(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getManagementUsersListByTowerId', {
        towerId: towerId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save management users Info
  public saveManagementUserInfo(managementUserInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveManagementUserInfo', {
        managementUserInfo: managementUserInfo,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update management users Info
  public updateManagementUserInfo(managementUserInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateManagementUserInfo', {
        managementUserInfo: managementUserInfo,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all user role list
  public getAllUserRoleList(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getAllUserRoleList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get modules config info
  public getModulesConfigInfo(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getModulesConfigList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get modules config info by tower id
  public getModulesConfigInfoBytowerId(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getModulesConfigInfoBytowerId', {
        towerId: towerId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save module config info
  public saveModuleConfigInfo(moduleConfig): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveModuleConfig', {
        moduleConfig: moduleConfig,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update module config info
  public updateModuleConfigInfo(moduleConfig): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateModuleConfig', {
        moduleConfig: moduleConfig,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get modules config info
  public getModuleConfigInfo(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getModuleConfigInfo', { towerId: towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Super users details
  public getSuperUserInfo(userName): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getSuperUserInfo', { userName: userName })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Super users list
  public getSuperUserList(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getSuperUserList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Save super info
  public saveSuperUserInfo(superUserInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveSuperUserInfo', {
        superUserInfo: superUserInfo,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update super user info
  public updationSuperUserInfo(superUserInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updationSuperUserInfo', {
        superUserInfo: superUserInfo,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all tower location infomation
  public getAllTowerLocationInfo(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getAllTowerLocationInfo').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Save accounts Info
  public saveTowerLocationInfo(towerLocationInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveTowerLocationInfo', {
        towerLocationInfo: towerLocationInfo,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update accounts info
  public updateTowerLocationInfo(towerLocationInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateTowerLocationInfo', {
        towerLocationInfo: towerLocationInfo,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get report email management config info
  public getReportEmailManagementConfigInfo(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getReportEmailInfoList').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get modules config info by tower id
  public getReportEmailManagementConfigInfoBytowerId(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getReportEmailInfoByTowerId', {
        towerId: towerId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save report email config info
  public saveReportEmailConfigInfo(reportEmailConfig): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveReportEmailConfig', {
        reportEmailConfig: reportEmailConfig,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update report email config info
  public updateReportEmailConfigInfo(reportEmailConfig): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateReportEmailConfig', {
        reportEmailConfig: reportEmailConfig,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save functional skill
  public saveFunSkill(ibuInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveFunSkill', { ibuInfo: ibuInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all functional skills
  public getAllFunSkills(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getAllFunSkills').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get all functional skills
  public postAllFunSkills(towerId?, positionId?): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'postAllFunSkills', {
        towerId: towerId,
        positionId: positionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // update functional skills
  public updateFunSkill(formInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateFunSkill', { formInfo: formInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save Behavioral Skill
  public saveBehSkill(ibuInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveBehSkill', { ibuInfo: ibuInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all behavioral skills
  public getAllBehSkills(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getAllBehSkills').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Get all behavioral skills
  public postAllBehSkills(towerId, positionId?): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'postAllBehSkills', {
        towerId: towerId,
        positionId: positionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  public getAllBehRatingsForUser(towerId, userId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllBehRatingsForUser', {
        towerId: towerId,
        userId: userId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  public getAllBehSelfRatingsForUser(towerId, userId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllBehSelfRatingsForUser', {
        towerId: towerId,
        userId: userId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all behavioral skills
  public getAllFunRatingsForUser(towerId, userId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllFunRatingsForUser', {
        towerId: towerId,
        userId: userId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all behavioral skills
  public getAllFunSelfRatingsForUser(towerId, userId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllFunSelfRatingsForUser', {
        towerId: towerId,
        userId: userId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // update behavioral skills
  public updateBehSkill(formInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateBehSkill', { formInfo: formInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get user skill rating information by user Id
  public getUserFunSkillRatingInfo(
    userId: any[],
    towerId,
    positionId
  ): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getUserSkillRatingInfo', {
        userId: userId,
        towerId: towerId,
        positionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get user skill rating information by user Id
  public getUserBehSkillRatingInfo(
    userId: any[],
    towerId,
    positionId
  ): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getUserBehSkillRatingInfo', {
        userId: userId,
        towerId: towerId,
        positionId: positionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save Skill Rating
  public saveSkillRating(formInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveSkillRating', { formInfo: formInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // update Skill Rating
  public updateSkillRating(formInfo): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateSkillRating', { formInfo: formInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all position info
  public getAllPositionInfo(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllPositions', { towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Save position info
  public savePositionInfo(position): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'savePosition', { position: position })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update position info
  public updatePositionInfo(position): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updatePosition', { position: position })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get all position info
  public fetchRoles(): Observable<any> {
    return this.http.get<any>(this.baseURL + 'getAllRoles').pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  // Save position info
  public saveRole(position): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'saveRole', { role: position })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Update position info
  public updateRole(position): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'updateRole', { role: position })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Target Role
  public getNextPosition(userId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getNextPosition', { userId: userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Target Role
  public allInfoPosition(positionId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'allInfoPosition', { positionId: positionId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Get Target Role
  public getAllNextPositions(userIds, towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllNextPositions', {
        userIds: userIds,
        towerId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  public getAllNextPositions2(userIds): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllNextPositions2', { userIds: userIds })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Send Email
  public sendEmailNiit(
    emailType,
    toEmail,
    ccEmail,
    isenabledBeh,
    isenabledFun,
    userId,
    towerId
  ): Observable<any> {
    console.log('>>>>>>>>>>>>sendEmailNiit');
    return this.http
      .post<any>(this.baseURL + 'sendEmailNiit', {
        emailType,
        toEmail: toEmail.toLowerCase(),
        ccEmail: ccEmail.toLowerCase(),
        isenabledBeh,
        isenabledFun,
        userId,
        towerId: towerId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  // Send Email to all
  public sendEmailToAll(type): Observable<any> {
    console.log('sendEmailToAll');
    var towerId = JSON.parse(localStorage.getItem('user')).userData.towerId;
    return this.http
      .post<any>(this.baseURL + 'sendEmailToAll', { type, towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  //shruti - 8/6/2020
  //Nominee Api
  //Get user details
  public getAUser(formDetails: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAUser', { formDetails: formDetails })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  //get Resouces for all nominated users
  public getAllResoucesForTower(formDetails: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getAllResoucesForTower', {
        formDetails: formDetails,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // hr can approve and disaprove the nominated user request
  public approveDisapprove(formDetails: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'approveDisapprove', {
        formDetails: formDetails,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // insert status history
  public statusHistoryData(formStatusDetails: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'statusHistoryData', {
        formStatusDetails: formStatusDetails,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  public userNewNominee(formDetails: any): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'userNewNominee', { formDetails: formDetails })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // Get user behavoral skill
  public getBehUserSkill(postData) {
    return this.http
      .post<any>(this.baseURL + 'getBehSkillsBytowerPosition', postData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  // Get user behavoral skill
  public getFunUserSkill(postData) {
    return this.http
      .post<any>(this.baseURL + 'getFunSkillsBytowerPosition', postData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * For reset user for renomination.
   */
  resetUserforRenomination(userData) {
    return this.http
      .post<any>(this.baseURL + 'resetUserForRenomination', userData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get function list by IBU ID
   */
  public getFunctionListByIbuId(ibuId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getFunctionsListByIbuId', { ibuId: ibuId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get nominated user istory by email.
   */
  getNominatedUserHistory(data) {
    return this.http
      .post<any>(this.baseURL + 'nominatedUserHistory', data)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get Beh. Competency data by tower Id.
   */
  public getBehDataByTowerIdReport(postData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getBehCompDataByTowerId', postData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get Fun. Competency data by tower Id.
   */
  public getFunDataByTowerIdReport(postData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getFunCompDataByTowerId', postData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get Beh. Competency data by tower Id.
   */
  public getBehDataByTowerIdReportForStatus(postData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getBehCompDataByTowerIdForStatus', postData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get Fun. Competency data by tower Id.
   */
  public getFunDataByTowerIdReportForStatus(postData): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getFunCompDataByTowerIdForStatus', postData)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Fetch users For Report
   */
  public getUsersForReportByTowerIdsArr(postData): Observable<any> {
    return this.http.post<any>(this.baseURL + 'usersForReport', postData).pipe(
      map((res) => {
        return res.data;
      })
    );
  }
  // =====For Skill Matrix ====
  /**
   * Save skill matrix data
   */
  public addSkillMatrixUserData(formDetails: any) {
    return this.http
      .post<any>(this.baseURL + 'addSkillMatrixUser', {
        formDetails: formDetails,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get the skill matrix user list.
   */
  public getSkillMatrixUsers(towerId): Observable<any> {
    return this.http
      .post<any>(this.baseURL + 'getSkillMatrixUsers', { towerId: towerId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Update user skill of skill matrix
   */
  userSkillInfo(formInfo: any) {
    return this.http
      .post<any>(this.baseURL + 'updateUserSkill', { formInfo: formInfo })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get the skill matrix user skill
   */
  getSkillMatrixUserSkill(userId) {
    return this.http
      .post<any>(this.baseURL + 'getSkillMatrixUserSkill', { userId: userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get the user competency by targetRoleId
   */
  getUserCompetency(targetRoleId) {
    return this.http
      .post<any>(this.baseURL + 'getUserCompetency', {
        targetRoleId: targetRoleId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Save function competency of skill matrix.
   */
  saveFunSkillRating(formData) {
    return this.http
      .post<any>(this.baseURL + 'saveFunSkillRatingSm', { formData: formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get User saved skill rating data.
   */
  getUserSavedFunRatingData(userId) {
    return this.http
      .post<any>(this.baseURL + 'userSavedFunRatingData', { userId: userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get the user Beh competency by targetRoleId
   */
  getUserBehCompetency(targetRoleId) {
    return this.http
      .post<any>(this.baseURL + 'getUserBehCompetency', {
        targetRoleId: targetRoleId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Save behavioral competency of skill matrix.
   */
  saveBehSkillRating(formData) {
    return this.http
      .post<any>(this.baseURL + 'saveBehSkillRatingSm', { formData: formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get User saved beh. skill rating data.
   */
  getUserSavedBehRatingData(userId) {
    return this.http
      .post<any>(this.baseURL + 'userSavedBehRatingData', { userId: userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get user functionl rating history
   */
  getUserFunSkillRatinghistory(userId, positionId) {
    return this.http
      .post<any>(this.baseURL + 'userFunSkillRatinghistory', {
        userId: userId,
        positionId: positionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Get user Beh. rating history
   */
  getUserBehSkillRatinghistory(userId, positionId) {
    return this.http
      .post<any>(this.baseURL + 'userBehSkillRatinghistory', {
        userId: userId,
        positionId: positionId,
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Save user notes
   */
  addUserNotes(formData) {
    return this.http
      .post<any>(this.baseURL + 'addUserNotes', { formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  /**
   * Save user notes
   */
  getUserNotes(userId) {
    return this.http.post<any>(this.baseURL + 'getUserNotes', { userId }).pipe(
      map((res) => {
        return res.data;
      })
    );
  }
  /**
   * Save user notes
   */
  getAllUserNotes(userId = null) {
    return this.http
      .post<any>(this.baseURL + 'getAllUserNotes', { userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  getUserStatus(status) {
    let trStatus = 'Pending';
    if (status == 0) {
      trStatus = 'Rejected';
    } else if (status == 1) {
      trStatus = 'Approved';
    } else if (status == 2) {
      trStatus = 'Not Initiated';
    } else if (status == 3) {
      trStatus = 'Closed';
    } else if (status == 4) {
      trStatus = 'Not Promoted';
    } else if (status == 5) {
      trStatus = 'Promoted';
    } else if (status == 6) {
      trStatus = 'Continued';
    } else if (status == 7) {
      trStatus = 'Submitted'; // Nominated
    }
    return trStatus;
  }
  getUserDetail(userId) {
    return this.http
      .post<any>(this.baseURL + 'getUserDetail', { userId: userId })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  saveUserProfileHistory(formData) {
    return this.http
      .post<any>(this.baseURL + 'saveUserProfileHistory', { formData })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  public importUserData(userFile: any): Observable<any> {
    return this.http.post<any>(this.baseURL + 'userUpload', userFile).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
